// Types
import { SharedApplicationVariables } from '@/types/env';

/** **IMPORTANT**: CAN BE CONSUMED BY THE SERVER OR CLIENT SIDE CODE! */
export const applicationEnv = (): SharedApplicationVariables => ({
  PortalId: process.env.PORTAL_ID ?? '',
  WebsiteUrl: process.env.WEBSITE_URL ?? '',
  WebsiteName: process.env.WEBSITE_NAME ?? '',

  ApplicationUrls: {
    SecurePortalUrl: process.env.SECURE_PORTAL_URL ?? '',
    OrderTestBaseUrl: process.env.ORDER_TEST_BASE_URL ?? '',
    ConsultationBaseUrl: process.env.CONSULTATION_BASE_URL ?? '',
    ServiceUserResultsBaseUrl: process.env.SERVICE_USER_RESULTS_BASE_URL ?? '',
  },
});
